// @flow
import React from 'react';
import './LetterContent.scss';

type Props = {
  body: string,
  theme: string,
  thumbnail: ?string,
  onSetToc: (toc: any) => void,
  onActivateHeading: (headingId: string) => void,
};

const LetterContent = ({ body }: Props) => (
  <div className="LetterContent">
    <div className="contents" dangerouslySetInnerHTML={{ __html: body }}></div>
  </div>
);

LetterContent.Placeholder = () => (
  <div className="LetterContent placeholder">
    <div className="letter-thumbnail">
      <div className="fake-img" />
    </div>
    <div className="contents">
      <div className="gray-block" />
      <div className="gray-block" />
      <div className="gray-block" style={{ width: '75%' }} />
      <div className="line-breaker" />
      <div className="gray-block" />
      <div className="gray-block" style={{ width: '40%' }} />
      <div className="line-breaker" />
      <div className="gray-block" />
      <div className="gray-block" />
      <div className="gray-block" />
      <div className="gray-block" style={{ width: '40%' }} />
    </div>
  </div>
);

export default LetterContent;



// WEBPACK FOOTER //
// ./src/components/letter/LetterContent/LetterContent.js